import { Tooltip } from "@mui/material";
import React, { useEffect, useState } from "react";
import { FcCalendar, FcDocument, FcViewDetails } from "react-icons/fc";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import { SortingRule } from "react-table";
import { Col, Row } from "reactstrap";
import { AssistanceUtilities } from "../../../AssistanceUtilities";
import ButtonComponent from "../../../components/ButtonComponent";
import InputComponent from "../../../components/InputComponent";
import MultiSelectComponent from "../../../components/MultiSelectComponent";
import { SelectItemsProps } from "../../../components/SearchSelectComponent";
import SelectComponent from "../../../components/SelectComponent";
import TableComponent from "../../../components/TableComponent";
import { useAvailableModulesContext } from "../../../context/AvailableModulesContext";
import Toast from "../../../helpers/Toast";
import { Utilities } from "../../../helpers/Utilities";
import { AssistanceListDTO } from "../../../models/Assistance/AssistanceListDTO";
import { CreateAssistanceDTO } from "../../../models/Assistance/CreateAssistanceDTO";
import { Parameter } from "../../../models/Parameter";
import { useNavigateToScheduleCreate } from "../../../ScheduleUtilities";
import { AssistanceService } from "../../../services/AssistanceService";
import { generatePDF } from "../../GeneratePDF";


export default function AssistanceIndexB() {
    const intl = useIntl();
    const pageSizes: number[] = [5, 10, 15, 30];
    const [data, setData] = useState<AssistanceListDTO[]>([]);
    const [loading, setLoading] = useState(false);
    const [pageCount, setPageCount] = useState(1);
    const navigate = useNavigate();
    const service = new AssistanceService();
    const { availableModules, assistanceTypes } = useAvailableModulesContext();
    const navigateToScheduleCreate = useNavigateToScheduleCreate();


    const [currentPage, setCurrentPage] = useState<number>();
    const [currentPageSize, setCurrentPageSize] = useState<number>();
    const [currentSorting, setCurrentSorting] = useState<SortingRule<object>[] | null>(null);
    const [reloadSearch, setReloadSearch] = useState<boolean>(false);
    const [isButtonCreateLoading, setIsButtonCreateLoading] = useState<boolean>(false);

    const [initialSortBy] = useState<SortingRule<object>[]>(Utilities.LoadSortParametersFromURLQuery("sortField", "sortOrder"));
    const [page] = useState<number>(Utilities.LoadPageFromURLQuery("page"));
    const [pageSize] = useState<number>(Utilities.LoadPageSizeFromURLQuery(pageSizes, 10));

    const [goToPage, setGoToPage] = useState<number>();

    const [carPlate, setCarPlate] = useState<string>(Utilities.LoadParameterFromURLQuery("carPlate", "string", ""));
    const [serialNumber, setSerialNumber] = useState<string>(Utilities.LoadParameterFromURLQuery("serialNumber", "string", ""));
    const [numDoc, setNumDoc] = useState<string>(Utilities.LoadParameterFromURLQuery("numDoc", "number", ""));
    const [status, setStatus] = useState<string>(Utilities.LoadParameterFromURLQuery("status", "string", "ABERTURA,FECHADA_TECNICAMENTE,EM_CURSO"));
    const [selectedTechnician, setSelectedTechnician] = useState<string>(Utilities.LoadParameterFromURLQuery("technician", "string", ""));
    const [techninians, setTechnicians] = useState<SelectItemsProps[]>([]);
    const [initialDate, setInitialDate] = useState<string>(Utilities.LoadParameterFromURLQuery("initialDate", "string", ""));
    const [endDate, setEndDate] = useState<string>(Utilities.LoadParameterFromURLQuery("endDate", "string", ""));
    const [selectedAssistanceType, setSelectedAssistanceType] = useState<string>(Utilities.LoadParameterFromURLQuery("assistanceType", "string", availableModules.includes("ShowAssistanceDefaultFilters") === true ? "Reparação" : ""));
    const [assistanceTypesComponent, setAssistanceTypesComponent] = useState<SelectItemsProps[]>([]);

    const [listStatus, setListStatus] = useState<SelectItemsProps[]>([]);

    const [isActiveSchedulerModule, setIsActiveSchedulerModule] = useState<boolean>(false);

    //modulos ativos
    useEffect(() => {
        if (availableModules.includes("IsActiveScheduler")) {
            setIsActiveSchedulerModule(true);
        }
    }, [availableModules]);

    const getAssistanceTypes = async () => {
        const list: SelectItemsProps[] = [];

        assistanceTypes.forEach((element) => {
            var item: SelectItemsProps = {
                value: element,
                label: element,
            };
            list.push(item);
        });

        setAssistanceTypesComponent(list);
    };

    const columns = React.useMemo(
        () => [
            {
                Header: "",
                accessor: " ",
                Cell: (props: any) => {
                    const isValidAssistanceStatusForScheduling = AssistanceUtilities.IsValidAssistanceStatusForScheduling(props.cell.row.original.status);
                    return (
                        <div style={{ display: "flex" }}>
                            <Tooltip title="Ver Detalhes" aria-label="Ver Detalhes" enterNextDelay={500} enterDelay={500}>
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        alignContent: "center",
                                        flexDirection: "column",
                                        cursor: "pointer",
                                    }}
                                    onClick={() => {
                                        createAssistance(
                                            "",
                                            props.cell.row.original.equipment.erpId,
                                            props.cell.row.original.client.erpId,
                                            props.cell.row.original.equipment.serialNumber,
                                            props.cell.row.original.equipment.brand,
                                            props.cell.row.original.equipment.model,
                                            props.cell.row.original.number,
                                            props.cell.row.original.docType,
                                            props.cell.row.original.serie
                                        );
                                    }}
                                >
                                    <FcViewDetails className="icons" />
                                </div>
                            </Tooltip>

                            {isActiveSchedulerModule && isValidAssistanceStatusForScheduling &&
                                <Tooltip title="Agendar" aria-label="Agendar" enterNextDelay={500} enterDelay={500}>
                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            alignContent: "center",
                                            flexDirection: "column",
                                            cursor: "pointer",
                                        }}
                                        onClick={() => navigateToScheduleCreate(
                                            props.cell.row.original.assistanceId,
                                            props.cell.row.original.docType,
                                            props.cell.row.original.serie,
                                            props.cell.row.original.number,
                                            props.cell.row.original.client,
                                            props.cell.row.original.equipment
                                        )}
                                    >
                                        <FcCalendar className="icons" />
                                    </div>
                                </Tooltip>
                            }

                            <Tooltip title="Relatório" aria-label="Relatório" enterNextDelay={500} enterDelay={500}>
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        alignContent: "center",
                                        flexDirection: "column",
                                        cursor: "pointer",
                                    }}
                                    onClick={() => {
                                        generatePDF(
                                            props.cell.row.original.number,
                                            props.cell.row.original.docType,
                                            props.cell.row.original.serie,
                                        );
                                    }}
                                >
                                    <FcDocument className="icons" />
                                </div>
                            </Tooltip>
                        </div>
                    );
                },
                width: 2,
            },
            {
                Header: "Id",
                width: 5,
                Cell: (props: any) => {
                    return Utilities.FormattedAssistanceDocument(props.cell.row.original.docType, props.cell.row.original.serie, props.cell.row.original.number);
                },
            },
            {
                Header: "Data",
                accessor: "date",
                width: 10,
                Cell: (props: any) => {
                    return props.cell.row.original.dateString;
                },
            },
            {
                Header: "Cliente",
                accessor: "client.name",
                width: 20,
            },
            {
                Header: "Matrícula",
                accessor: "equipment.carPlate",
                width: 10,
            },
            {
                Header: "Nº Série",
                accessor: "equipment.serialNumber",
                width: 5,
            },
            {
                Header: "Marca",
                accessor: "equipment.brand",
                width: 10,
            },
            {
                Header: "Modelo",
                accessor: "equipment.model",
                width: 10,
            },
            {
                Header: "Técnico",
                accessor: "technician",
                width: 10,
            },
            {
                Header: "Estado",
                accessor: "status",
                width: 10,
            },
            {
                Header: "Tipo de Assistência",
                accessor: "assistanceType",
                width: 10,
            },
        ],
        [isButtonCreateLoading, isActiveSchedulerModule]
    );

    const getStatus = async () => {
        var response = await service.GetStatus();
        if (response.success === false) {
            Toast.Show("error", response.message);
            return;
        }

        var items: SelectItemsProps[] = [];
        response.obj.forEach((element) => {
            var item: SelectItemsProps = {
                value: element.enumValue,
                label: element.name,
            };
            items.push(item);
        });

        setListStatus(items);
    };

    const getTechnicians = async () => {
        const list: SelectItemsProps[] = [];
        var response = await service.GetWorkshopTechniciansWithCode();

        if (response.success === false) {
            Toast.Show("error", response.message);
            return;
        }

        response.obj.forEach((element) => {
            var item: SelectItemsProps = {
                value: element.id,
                label: element.name,
            };
            list.push(item);
        });

        setTechnicians(list);
    };

    const createAssistance = async (projectErpId: string, equipmentErpId: string, equipmentNumSerie: string, equipmentBrand: string, equipmentModel: string, clientErpId: string, numDoc: number, typeDoc: string, serie: string) => {
        var sendData: CreateAssistanceDTO = {
            equipmentErpId: equipmentErpId,
            equipmentNumSerie: equipmentNumSerie,
            equipmentBrand: equipmentBrand,
            equipmentModel: equipmentModel,
            projectErpId: null,
            clientErpId: clientErpId,
            numDoc: numDoc,
            typeDoc: typeDoc,
            serie: serie,
            id: 0,
            date: new Date(),
            description: null,
            notes: null,
            clientId: null,
            counter1: 0,
            counter2: 0,
            counter3: 0,
            assistanceType: null,
            stockEntryDocumentErpId: null,
            budgetSellingPrice: null,
            budgetCostPrice: null
        };

        setIsButtonCreateLoading(true);
        var response = await service.Create(sendData);
        setIsButtonCreateLoading(false);

        if (response.success === false) {
            Toast.Show("error", response.message);
            return;
        }
        navigate(`/Backoffice/Assistance/${response.obj}`);
    };

    const fetchData = async (page: number, pageSize: number, sortBy: SortingRule<object>[] | null) => {
        var searchUrl: string = Utilities.CreateSearchURL([
            `page=${page}`,
            `pageSize=${pageSize}`,
            Utilities.AddParamToQueryIfValue("carPlate", "string", carPlate),
            Utilities.AddParamToQueryIfValue("serialNumber", "string", serialNumber),
            Utilities.AddParamToQueryIfValue("numDoc", "number", numDoc),
            Utilities.AddParamToQueryIfValue("status", "string", status),
            Utilities.AddParamToQueryIfValue("technician", "string", selectedTechnician),
            Utilities.AddParamToQueryIfValue("initialDate", "string", initialDate),
            Utilities.AddParamToQueryIfValue("endDate", "string", endDate),
            Utilities.AddParamToQueryIfValue("assistanceType", "string", selectedAssistanceType)
        ]);
        if (sortBy != null && sortBy.length > 0) {
            searchUrl += `${Utilities.AddParamToQueryIfValue("sortField", "string", sortBy[0].id)}${Utilities.AddParamToQueryIfValue(
                "sortOrder",
                "string",
                sortBy[0].desc === true ? "DESC" : "ASC"
            )}`;
        }
        navigate({
            pathname: "/Backoffice",
            search: searchUrl,
        });

        setLoading(true);
        var response = await service.GetAll(mountSearchParameters(), Utilities.MountSortParameters(sortBy), page, pageSize);
        if (response.success !== true) {
            setCurrentPage(1);
            setGoToPage(1);
            setData([]);
            setPageCount(0);
            setLoading(false);
            setCurrentSorting(null);
            Toast.Show("error", response.message);
            return;
        }

        if (response.items.length === 0) {
            setCurrentPage(1);
            setGoToPage(1);
            Toast.Show("info", "Não existe nenhuma assistência com esses dados");
        }
        setData(response.items);
        setPageCount(response.totalPages);
        setLoading(false);
        setCurrentPageSize(pageSize);
        setCurrentPage(page);
        setCurrentSorting(sortBy);
        setGoToPage(0);

        if (response.totalPages > 0 && page > response.totalPages) {
            setGoToPage(1);
        }
    };

    const mountSearchParameters = (): Parameter[] => {
        var parameters: Parameter[] = [];
        parameters.push(new Parameter("carPlate", carPlate));
        parameters.push(new Parameter("serialNumber", serialNumber));
        parameters.push(new Parameter("numDoc", numDoc));
        parameters.push(new Parameter("status", status));
        parameters.push(new Parameter("technician", selectedTechnician));
        parameters.push(new Parameter("initialDate", initialDate));
        parameters.push(new Parameter("endDate", endDate));
        parameters.push(new Parameter("assistanceType", selectedAssistanceType));

        return parameters;
    };

    const onEnter = () => {
        fetchData(currentPage ?? 1, currentPageSize ?? 10, currentSorting);
    };

    const onButtonClick = () => {
        setCurrentPage(1);
        setGoToPage(1);
        fetchData(currentPage ?? 1, currentPageSize ?? 10, currentSorting);
    };

    const onRemoveFiltersClick = () => {
        setCurrentPage(1);
        setGoToPage(1);
        setCarPlate("");
        setSerialNumber("");
        setNumDoc("");
        setStatus("");
        setSelectedTechnician("");
        setReloadSearch(true);
        setInitialDate("");
        setEndDate("");
        setSelectedAssistanceType("");
    };

    useEffect(() => {
        if (reloadSearch === true) {
            fetchData(currentPage ?? 1, currentPageSize ?? 5, currentSorting);
            setReloadSearch(false);
        }
    }, [reloadSearch]);

    useEffect(() => {
        getStatus();
        getTechnicians();
        getAssistanceTypes();
    }, []);

    return (
        <>
            <Row>
                <InputComponent
                    xl={2}
                    lg={3}
                    md={5}
                    sm={12}
                    xs={12}
                    style={{ width: "100%", height: "43px" }}
                    type={"text"}
                    label={intl.formatMessage({
                        id: "Screens.Assistances.Filters.NumDoc",
                    })}
                    readOnly={false}
                    value={numDoc}
                    onEnter={onEnter}
                    onChange={(t: string) => setNumDoc(t)}
                />
                <InputComponent
                    xl={2}
                    lg={3}
                    md={5}
                    sm={12}
                    xs={12}
                    style={{ width: "100%", height: "43px" }}
                    type={"text"}
                    label={intl.formatMessage({
                        id: "Screens.Assistances.Filters.CarPlate",
                    })}
                    readOnly={false}
                    value={carPlate}
                    onEnter={onEnter}
                    onChange={(t: string) => setCarPlate(t)}
                />

                <InputComponent
                    xl={2}
                    lg={3}
                    md={5}
                    sm={12}
                    xs={12}
                    style={{ width: "100%", height: "43px" }}
                    type={"text"}
                    label={intl.formatMessage({
                        id: "Screens.Assistances.Filters.SerialNumber",
                    })}
                    readOnly={false}
                    value={serialNumber}
                    onEnter={onEnter}
                    onChange={(t: string) => setSerialNumber(t)}
                />
                <SelectComponent
                    xl={2}
                    lg={3}
                    md={5}
                    sm={12}
                    xs={12}
                    style={{ width: "100%", height: "43px" }}
                    label={"Técnico"}
                    selectedItemValue={selectedTechnician}
                    items={techninians}
                    onChange={(t: string) => {
                        setSelectedTechnician(t);
                    }}
                />

                <SelectComponent
                    xl={2}
                    lg={3}
                    md={5}
                    sm={6}
                    xs={12}
                    style={{ width: "100%", height: "43px" }}
                    label={"Tipo de Assistência"}
                    selectedItemValue={selectedAssistanceType}
                    items={assistanceTypesComponent}
                    onChange={(t: string) => {
                        setSelectedAssistanceType(t);
                    }}
                />
                <MultiSelectComponent xl={3} lg={3} md={5} sm={12} xs={12} style={{ width: "50%" }} label={intl.formatMessage({ id: "Screens.Assistances.Filters.Status" })} items={listStatus} setSelectedString={setStatus} selectString={status} />

                <InputComponent
                    xl={2}
                    lg={2}
                    md={2}
                    sm={2}
                    xs={2}
                    style={{ width: "100%" }}
                    type={"date"}
                    onEnter={onEnter}
                    value={initialDate}
                    label={intl.formatMessage({ id: "Screens.Assistances.Filters.InitialDate" })}
                    readOnly={false}
                    onChange={(t: string) => setInitialDate(t)}
                />
                <InputComponent
                    xl={2}
                    lg={2}
                    md={2}
                    sm={2}
                    xs={2}
                    style={{ width: "100%" }}
                    type={"date"}
                    onEnter={onEnter}
                    value={endDate}
                    label={intl.formatMessage({ id: "Screens.Assistances.Filters.FinalDate" })}
                    readOnly={false}
                    onChange={(t: string) => setEndDate(t)}
                />

            </Row>
            <Row>
                <Col xl={3} lg={3} md={3} sm={12} xs={12} style={{ marginTop: "1em", display: "inline-flex", gap: "1rem" }}>
                    <ButtonComponent text={intl.formatMessage({ id: "Common.Buttons.Search" })} onClick={onButtonClick} />
                    <ButtonComponent
                        text={intl.formatMessage({
                            id: "Common.Buttons.RemoveFilters",
                        })}
                        onClick={onRemoveFiltersClick}
                    />
                </Col>
            </Row>

            <div className="pageComponent" style={{ width: "100%" }}>
                <TableComponent
                    goToPage={goToPage}
                    loading={loading}
                    pageCount={pageCount}
                    columns={columns}
                    manualPagination={true}
                    fetchData={fetchData}
                    pageSizes={pageSizes}
                    initialPage={page}
                    initialPageSize={pageSize}
                    initialSortBy={initialSortBy}
                    data={data}
                    dontOrderFirstCollumn={true}
                />
            </div>
        </>
    );
}
